(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.ubMoneyFormat || '£{{amount}}');
    }
    return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---- Variant change ---- */
  function onVariantChange(sel) {
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('[data-card]');
    if (!card || !opt) return;

    var vid = opt.value;
    var price = parseInt(opt.getAttribute('data-price') || 0, 10);
    var comp = parseInt(opt.getAttribute('data-compare') || 0, 10);
    var avail = opt.getAttribute('data-available') !== 'false';

    card.setAttribute('data-variant-id', vid);
    card.setAttribute('data-price', price);
    card.setAttribute('data-available', avail ? 'true' : 'false');
    if (comp > price) card.setAttribute('data-was', comp);
    else card.removeAttribute('data-was');

    var now = card.querySelector('[data-price-now]');
    var was = card.querySelector('[data-price-was]');
    var save = card.querySelector('[data-save]');
    if (now) now.textContent = money(price);
    if (was) { if (comp > price) { was.textContent = money(comp); was.style.display = ''; } else { was.style.display = 'none'; } }
    if (save) { if (comp > price) { save.textContent = 'Save ' + money(comp - price); save.style.display = ''; } else { save.style.display = 'none'; } }

    /* reflect availability on the add button */
    var btn = card.querySelector('[data-add]');
    var lbl = card.querySelector('[data-add-label]');
    if (btn) {
      btn.disabled = !avail;
      if (lbl) lbl.textContent = avail ? (window.ubAddLabel || 'Add to cart') : 'Sold out';
      card.classList.toggle('ub-card--soldout', !avail);
    }
  }

  /* ====================================================================
     CART REFRESH — Horizon / Ritual

     IMPORTANT: In Horizon-family themes the cart drawer re-renders ITSELF
     when it receives the theme's cart events. We must NOT try to inject
     section HTML ourselves — we just fire the events the theme listens
     for, using a `source` value the theme actually recognises
     ('product-form-component'). This is the pattern confirmed working on
     Horizon 3.0.0.

     Why the old code failed: it used a made-up `source` ('ub-card') and
     passed junk into `sections`, so the cart drawer's listener ignored
     the event and never re-fetched its contents — the item WAS added
     (hence "✓ Added") but the drawer stayed showing "empty" until a
     page reload forced a fresh render.
  ===================================================================== */

  function findCartDrawer() {
    return document.querySelector('cart-drawer-component')
        || document.querySelector('cart-drawer')
        || document.querySelector('#cart-drawer')
        || document.querySelector('[id^="cart-drawer"]');
  }

  function openDrawer(drawer) {
    drawer = drawer || findCartDrawer();
    if (!drawer) return;
    /* Horizon exposes open() as a method; some builds use an attribute. */
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
    try { drawer.open = true; } catch (e) {}
    if (drawer.setAttribute) drawer.setAttribute('open', '');
  }

  /* Fire every event Horizon-family themes may listen for, then open. */
  function refreshCart(cart) {
    var drawer = findCartDrawer();

    /* 1) The simple CustomEvent confirmed working on Horizon 3.0.0.
          The theme's cart drawer re-fetches its own section on this. */
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: cart ? cart.item_count : undefined, source: 'product-form-component' } }
    }));

    /* 2) The typed CartUpdateEvent from @theme/events, using a source the
          theme recognises. Wrapped in import() so it's a no-op if absent. */
    import('@theme/events')
      .then(function (mod) {
        var CartUpdateEvent = mod && mod.CartUpdateEvent;
        if (CartUpdateEvent && cart) {
          document.dispatchEvent(new CartUpdateEvent(cart, 'product-form-component', {
            itemCount: cart.item_count,
            source: 'product-form-component'
          }));
        }
      })
      .catch(function () { /* theme has no @theme/events — the CustomEvent above covers it */ })
      .finally(function () { openDrawer(drawer); });

    /* 3) Open immediately too, in case the import is slow. Opening twice is harmless. */
    openDrawer(drawer);
  }

  /* ====================================================================
     PER-CARD ADD TO CART
  ===================================================================== */
  function addCard(card) {
    if (!card) return;
    if (card.getAttribute('data-available') === 'false') return;

    var vid = parseInt(card.getAttribute('data-variant-id'), 10);
    if (!vid) return;

    var btn = card.querySelector('[data-add]');
    var lbl = card.querySelector('[data-add-label]');
    var origLabel = lbl ? lbl.textContent : '';
    if (btn) btn.disabled = true;
    if (lbl) lbl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (addData) {
        if (btn) btn.classList.add('ub-add--ok');
        if (lbl) lbl.textContent = '✓ Added';
        /* Get the fresh cart object, then let the theme re-render its drawer. */
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { refreshCart(cart); })
          .catch(function () { refreshCart(null); });
      })
      .then(function () {
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('ub-add--ok'); }
          if (lbl) lbl.textContent = origLabel || (window.ubAddLabel || 'Add to cart');
        }, 2000);
      })
      .catch(function (e) {
        console.warn('[ub] add failed', e);
        if (lbl) lbl.textContent = (e && e.description) ? (String(e.description).length > 24 ? 'Unavailable' : e.description) : 'Try again';
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (lbl) lbl.textContent = origLabel || (window.ubAddLabel || 'Add to cart');
        }, 2400);
      });
  }

  /* ---- Recommendations fallback ---- */
  function loadRecommendations(wrap) {
    var holder = wrap.querySelector('[data-recommend]');
    if (!holder) return;
    holder.innerHTML = '<div class="ub-skel-card"></div><div class="ub-skel-card"></div><div class="ub-skel-card"></div>';
    var pid = wrap.getAttribute('data-product-id') || '';
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=3&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.products || !d.products.length) { hideEmpty(wrap); return; }
        holder.classList.remove('ub-grid-inner');
        holder.outerHTML = d.products.map(function (p) {
          var v = p.variants[0];
          var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '';
          var hasVar = p.variants.length > 1;
          var url = p.url || ('/products/' + p.handle);
          var avail = (v && v.available !== false);
          var selectHtml = '';
          if (hasVar) {
            selectHtml = '<select class="ub-variant" data-variant-select>'
              + p.variants.map(function (vv) {
                  return '<option value="' + vv.id + '" data-price="' + vv.price + '" data-compare="0" data-available="' + (vv.available !== false) + '"'
                    + (vv.id === v.id ? ' selected' : '') + (vv.available === false ? ' disabled' : '') + '>'
                    + (vv.title || vv.name || 'Option') + (vv.available === false ? ' — Sold out' : '') + '</option>';
                }).join('')
              + '</select>';
          }
          return '<div class="ub-card' + (avail ? '' : ' ub-card--soldout') + '" data-card data-variant-id="' + v.id + '" data-price="' + v.price + '"'
            + ' data-available="' + (avail ? 'true' : 'false') + '">'
            + '<a class="ub-view" href="' + url + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg><span>View</span></a>'
            + '<div class="ub-thumb">' + img + '</div>'
            + '<div class="ub-nm">' + p.title + '</div>'
            + selectHtml
            + '<div class="ub-pr"><span data-price-now>' + money(v.price) + '</span></div>'
            + '<div class="ub-meta"><span class="ub-meta-add">&nbsp;</span></div>'
            + '<button class="ub-add" type="button" data-add' + (avail ? '' : ' disabled') + '>'
            + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
            + '<span data-add-label>' + (avail ? (window.ubAddLabel || 'Add to cart') : 'Sold out') + '</span></button>'
            + '</div>';
        }).join('');
      })
      .catch(function () { hideEmpty(wrap); });
  }

  function hideEmpty(wrap) {
    if (window.Shopify && Shopify.designMode) { var h = wrap.querySelector('[data-recommend]'); if (h) h.innerHTML = ''; return; }
    wrap.style.display = 'none';
  }

  /* ---- Wire up ---- */
  function initWrap(wrap) {
    if (wrap._ubInit) return;
    wrap._ubInit = true;

    wrap.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add]');
      if (addBtn) {
        e.preventDefault();
        addCard(addBtn.closest('[data-card]'));
      }
    });

    wrap.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-variant-select]');
      if (sel) onVariantChange(sel);
    });

    loadRecommendations(wrap);
  }

  function boot() { document.querySelectorAll('.ub-wrap').forEach(initWrap); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
